import admin from '@/utils/http'

export default {
  state: {
    batchno: {
      batchID: 0,
      // traceList: [],
      // orderList: [],
    }
  },
  actions: {
    // 商品
    create(data) {
      return admin.post('/product/create', data)
    },
    fetchList(query) {
      return admin.get('/product/list', { query })
    },
    remove(id) {
      return admin.delete('/product/delete/' + id)
    },
    update(data) {
      return admin.put('/product/update/' + data.id, data)
    },
    detail(id) {
      return admin.get('/product/detail/' + id).then(res => res.product)
    },
    // 批号
    createBatchNo(data) {
      return admin.post('/batchno/create', data)
    },
    updateBatchNo(data) {
      return admin.put('/batchno/update/' + data.id, data)
    },
    async batchNoDetail(id) {
      if (this.batchno.batchID == id) {
        return this.batchno
      }
      const res = await admin.get('/batchno/detail/' + id)
      this.batchno = {
        ...res,
        batchID: res.id,
      }
      return this.batchno
    },
    batchNoRemove(id) {
      return admin.delete('/batchno/delete/' + id)
    },
    // 溯源
    async traceList(batchID, query) {
      const { list } = await admin.get('/trace/list/' + batchID, { query })
      // this.batchno.traceList = list
      return list
    },
    traceDetail(traceID) {
      return admin.get('/trace/detail/' + traceID)
    },
    traceCreate(data) {
      return admin.post('/trace/create', data)
    },
    traceUpdate(data) {
      return admin.put('/trace/update/' + data.id, data)
    },
    traceRemove(id) {
      return admin.delete('/trace/delete/' + id)
    },
  }
}